import { ColumnDef } from '@tanstack/react-table'
import { GetBannedPlayerTableData } from '@/modules/manage-player/type'
import { Badge } from '@/common/ui/badge'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { PlayerTagsCell } from '@/common/components/PlayerTagsCell'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'
import AssignPlayerTagsModal from '@/modules/manage-player/components/GetPlayerList/components/GetPlayerListTable/CellAction/components/AssignPlayerTagsModal'
import type { PlayerTagResponse } from '@/modules/tags/types'

export const columns: ColumnDef<GetBannedPlayerTableData>[] = [
	{
		accessorKey: 'username',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			const { id, username, phone, tags, lastLogin } = row.original
			return (
				<div className="space-y-1">
					<div className="block">
						<UsernameCell username={username} />
					</div>
					<div className="block">
						<PhoneCell playerId={id} phone={phone} />
					</div>
					<div className="block">
						<PlayerTagsCell tags={tags || []} />
					</div>
					<p className="text-xs text-muted-foreground">
						IP ล่าสุด: {lastLogin?.ipAddress || '-'}
					</p>
					<AssignPlayerTagsModal
						playerId={id}
						playerPhone={phone}
						currentTags={tags as unknown as PlayerTagResponse[]}
					/>
				</div>
			)
		},
	},
	{
		accessorKey: 'banReason',
		header: 'สถานะ/เหตุผล',
		cell: ({ row }) => (
			<div className="space-y-1">
				<Badge variant={row.original.isBanned ? 'destructive' : 'default'}>
					{row.original.isBanned ? 'แบน' : 'ไม่แบน'}
				</Badge>
				<p
					className="max-w-[220px] truncate text-sm"
					title={row.original.banReason}
				>
					{row.original.banReason || '-'}
				</p>
				<p className="text-xs text-muted-foreground">
					แบนเมื่อ:{' '}
					{row.original.bannedAt
						? new Date(row.original.bannedAt).toLocaleString()
						: '-'}
				</p>
				<p className="text-xs text-muted-foreground">
					ออนไลน์ล่าสุด:{' '}
					{row.original.lastOnline
						? new Date(row.original.lastOnline).toLocaleDateString('th-TH', {
								year: 'numeric',
								month: '2-digit',
								day: '2-digit',
							})
						: '-'}
				</p>
			</div>
		),
	},
	{
		id: 'details',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<Button asChild variant="outline">
				<Link to={`/operator/get-player-list/player-detail/${row.original.id}`}>
					ดูข้อมูลผู้เล่น
				</Link>
			</Button>
		),
	},
]
